import { apiClient } from "lib/apiClient";
import { IResearchHistoryEntry } from "features/Research/types";

export const getResearchWorkItemHistory = async (
  workItemId: string
): Promise<IResearchHistoryEntry[]> => {
  const response = await apiClient.get(
    `/research/work-items/${workItemId}/history`
  );
  return response.data;
};
